import React, { useEffect, useState } from "react";

import List from "@mui/joy/List";
import ListItem from "@mui/joy/ListItem";
import Radio from "@mui/joy/Radio";
import RadioGroup from "@mui/joy/RadioGroup";

import ToothPosition from "./toothPosition";
import { OrderTypeEnum } from "../enums/OrderEnum";
import axiosInstance from "../services/axiosInstance";
import { useRef } from "react";

const DynamicQuestionRenderingv2 = ({
  initialRender,
  orderData,
  setOrderData,
  orderTypeId,
  toothGridData,
  setToothGridData,
  alloyType,
  setAlloyType,
  selectedFlow,
  setSelectedflow,
  errors,
}) => {
  const toothGridInitialRendering = useRef(0);
  const [availableOptions, setAvailableOptions] = useState({});
  const [allQuestionList, setAllQuestionList] = useState([]);
  // const [selectedToothColourId, setSelectedToothColourId] = useState(
  //   orderData.toothColourId
  // );
  // const [selectedToothColourOption, setSelectedToothColourOption] = useState(
  //   orderData.toothColorOption
  // );
  const listOfOptions = [
    "jobTypeName",
    "jobTypeSpecName1",
    "jobTypeSpecName2",
    "jobTypeSpecName3",
    "materialName",
    "alloyTypes_JSON",
    "coverageTypeName",
    "workStepName",
    "jawTypes_JSON",
    "toothColors_JSON",
    "gridLetters",
  ];

  const [selectedValues, setSelectedValues] = useState({
    jobTypeName: null,
    jobTypeSpecName1: null,
    jobTypeSpecName2: null,
    jobTypeSpecName3: null,
    materialName: null,
    alloyTypes_JSON: null,
    coverageTypeName: null,
    workStepName: null,
    jawTypes_JSON: null,
    toothColors_JSON: null,
    gridLetters: null,
  });

  // Update selected values.
  const handleSelection = (levelName, selectedvalue, stopReRender = false) => {
    if (stopReRender) {
      initialRender.current = false;
    }
    setSelectedValues((prevValues) => ({
      ...prevValues,
      [levelName]: selectedvalue,
    }));

    const currentQuestionIndex = listOfOptions.indexOf(levelName);
    deleteChildElements(currentQuestionIndex);

    if (levelName === listOfOptions[5]) {
      var testRemainingQuestion = availableOptions[levelName].filter((x) =>
        x.alloyTypeID.split(",").includes(String(selectedvalue))
      );
    } else {
      var testRemainingQuestion = availableOptions[levelName]?.filter(
        (x) => x[levelName] == selectedvalue
      );
    }

    testRemainingQuestion &&
      updateQuestionList(currentQuestionIndex, testRemainingQuestion);
  };

  const updateQuestionList = async (
    currentQuestionIndex,
    testRemainingQuestion
  ) => {
    if (
      testRemainingQuestion != undefined &&
      currentQuestionIndex <= listOfOptions.length + 1
    ) {
      const nextQuestion = {
        [listOfOptions[currentQuestionIndex + 1]]: testRemainingQuestion,
      };
      const nextObjavailable =
        testRemainingQuestion?.filter(
          (x) => x[listOfOptions[currentQuestionIndex + 1]]
        ).length > 0;
      if (testRemainingQuestion.length === 1) {
        setOrderData((prevState) => ({
          ...prevState,
          workTypeId: testRemainingQuestion[0].workTypeId,
        }));
        setSelectedflow(testRemainingQuestion[0]);

        getStandardNotesByWorkType(testRemainingQuestion[0].workTypeId);
      }

      if (testRemainingQuestion.length === 1) {
        setOrderData((prevState) => ({
          ...prevState,
          workTypeId: testRemainingQuestion[0].workTypeId,
        }));
        setSelectedflow(testRemainingQuestion[0]);
      }

      if (nextQuestion != null && nextObjavailable) {
        if (listOfOptions[currentQuestionIndex + 1] === listOfOptions[9]) {
          testRemainingQuestion = mapToothJsonData(testRemainingQuestion[0]);
        }
        await setAvailableOptions((prevValues) => ({
          ...prevValues,
          [listOfOptions[currentQuestionIndex + 1]]: testRemainingQuestion,
        }));
      } else {
        testRemainingQuestion &&
          updateQuestionList(currentQuestionIndex + 1, testRemainingQuestion);
      }
    }
  };

  const mapToothJsonData = (data) => {
    const toothColors = JSON.parse(data.toothColors_JSON);

    return toothColors.map((toothColor) => ({
      ...data,
      ToothColorId: toothColor.ToothColorId,
      ToothColor: toothColor.ToothColor,
      ToothColourOptions: toothColor.ToothColourOptions,
    }));
  };

  const deleteChildElements = (currentIndex) => {
    for (var i = currentIndex + 1; i < listOfOptions.length; i++) {
      if (listOfOptions[i] === listOfOptions[9]) {
        setOrderData((prevState) => ({
          ...prevState,
          // toothColorId: null,
          // toothColorOption: null,
          workTypeId: null,
        }));
        setSelectedflow(null);
      }
      delete availableOptions[listOfOptions[i]];
    }
  };

  const updateAndDeleteChildElement = (index) => {
    setSelectedValues((prevValues) => {
      let updatedValues = { ...prevValues };

      // Reset all child keys (after the given index)
      for (let i = index + 1; i < listOfOptions.length; i++) {
        updatedValues[listOfOptions[i]] = null;
        setOrderData((prevState) => ({
          ...prevState,
          //standard_Notes: null,
          toothColorId: null,
          toothColorOption: null,
        }));
        if (index < 7) {
          setOrderData((prevState) => ({
            ...prevState,
            jawTypeId: null,
          }));
        }

        setToothGridData([]);
      }

      if (index <= 7) {
        setOrderData((prevState) => ({
          ...prevState,
          jawTypeId: null,
        }));
      }

      return updatedValues;
    });
  };

  const getStandardNotesByWorkType = async (selectedWorkTypeId) => {
    try {
      if (selectedWorkTypeId && orderData?.dentistId > 0) {
        var url = `/api/Order/getStandardNotesByWorkType?dentistId=${orderData?.dentistId}&workTypeId=${selectedWorkTypeId}`;
        const response = await axiosInstance.get(url);

        setOrderData((prevState) => ({
          ...prevState,
          standard_Notes: response.standard_Notes,
        }));
      }
    } catch (ex) {
      console.error("", ex);
    }
  };

  useEffect(() => {
    if (orderTypeId) 
      getQuestions(orderTypeId);
  }, [orderTypeId]);

  useEffect(() => {
    var autoSelectedData = allQuestionList?.find(
      (x) => x.workTypeId == orderData?.workTypeId
    );
    if (
      orderData.workTypeId &&
      allQuestionList.length > 0 &&
      autoSelectedData
    ) {
      setSelectedValues({
        jobTypeName: autoSelectedData.jobTypeName || null,
        jobTypeSpecName1: autoSelectedData.jobTypeSpecName1 || null,
        jobTypeSpecName2: autoSelectedData.jobTypeSpecName2 || null,
        jobTypeSpecName3: autoSelectedData.jobTypeSpecName3 || null,
        materialName: autoSelectedData.materialName || null,
        alloyTypes_JSON: autoSelectedData.alloyTypes_JSON || null,
        coverageTypeName: autoSelectedData.coverageTypeName || null,
        workStepName: autoSelectedData.workStepName || null,
        jawTypes_JSON: autoSelectedData.jawTypes_JSON || null,
        toothColors_JSON: autoSelectedData.toothColors_JSON || null,
        gridLetters: autoSelectedData.gridLetters || null,
      });
    }
  }, [orderData.workTypeId, allQuestionList]);

  useEffect(() => {
    setSelectedValues({
      jobTypeName: null,
      jobTypeSpecName1: null,
      jobTypeSpecName2: null,
      jobTypeSpecName3: null,
      materialName: null,
      alloyTypes_JSON: null,
      coverageTypeName: null,
      workStepName: null,
      jawTypes_JSON: null,
      toothColors_JSON: null,
      gridLetters: null,
    });
    setOrderData((prevState) => ({
      ...prevState,
      // standard_Notes: "",
      // toothColorId: null,
      // toothColorOption: null,
      //jawTypeId: null,
    }));

    const jobTypeNameData = availableOptions?.jobTypeName;
    setAvailableOptions({ jobTypeName: jobTypeNameData });
  }, [orderData.dentistId]);

  useEffect(() => {
    if (initialRender.current) {
      if (
        selectedValues.jobTypeName &&
        availableOptions.jobTypeName !== selectedValues.jobTypeName
      ) {
        handleSelection("jobTypeName", selectedValues.jobTypeName);
      }
    }
  }, [selectedValues.jobTypeName, availableOptions.jobTypeName, initialRender]);

  useEffect(() => {
    if (initialRender.current) {
      if (
        selectedValues.jobTypeSpecName1 &&
        availableOptions.jobTypeSpecName1 !== selectedValues.jobTypeSpecName1
      ) {
        handleSelection("jobTypeSpecName1", selectedValues.jobTypeSpecName1);
      }
    }
  }, [availableOptions.jobTypeSpecName1, initialRender]);

  useEffect(() => {
    if (initialRender.current) {
      if (
        selectedValues.jobTypeSpecName2 &&
        availableOptions.jobTypeSpecName2 !== selectedValues.jobTypeSpecName2
      ) {
        handleSelection("jobTypeSpecName2", selectedValues.jobTypeSpecName2);
      }
    }
  }, [
    selectedValues.jobTypeSpecName2,
    availableOptions.jobTypeSpecName2,
    initialRender,
  ]);

  useEffect(() => {
    if (initialRender.current) {
      if (
        selectedValues.jobTypeSpecName3 &&
        availableOptions.jobTypeSpecName3 !== selectedValues.jobTypeSpecName3
      ) {
        handleSelection("jobTypeSpecName3", selectedValues.jobTypeSpecName3);
      }
    }
  }, [
    selectedValues.jobTypeSpecName3,
    availableOptions.jobTypeSpecName3,
    initialRender,
  ]);

  useEffect(() => {
    if (initialRender.current) {
      if (
        selectedValues.materialName &&
        availableOptions.materialName !== selectedValues.materialName
      ) {
        handleSelection("materialName", selectedValues.materialName);
      }
    }
  }, [availableOptions.materialName, initialRender]);

  useEffect(() => {
    if (initialRender.current) {
      if (alloyType && alloyType > 0) {
        handleSelection(listOfOptions[5], alloyType);
      }
    }
  }, [availableOptions.alloyTypes_JSON, initialRender]);

  useEffect(() => {
    if (initialRender.current) {
      if (
        selectedValues.coverageTypeName &&
        availableOptions.coverageTypeName !== selectedValues.coverageTypeName
      ) {
        handleSelection("coverageTypeName", selectedValues.coverageTypeName);
      }
    }
  }, [
    selectedValues.coverageTypeName,
    availableOptions.coverageTypeName,
    initialRender,
  ]);

  useEffect(() => {
    if (initialRender.current) {
      if (
        selectedValues.workStepName &&
        availableOptions.workStepName !== selectedValues.workStepName
      ) {
        handleSelection("workStepName", selectedValues.workStepName);
      }
    }
  }, [availableOptions.workStepName, initialRender]);

  useEffect(() => {
    if (initialRender.current) {
      if (
        selectedValues.jawTypes_JSON &&
        availableOptions.jawTypes_JSON !== selectedValues.jawTypes_JSON
      ) {
        handleSelection("jawTypes_JSON", selectedValues.jawTypes_JSON);
      }
    }
  }, [availableOptions.jawTypes_JSON, initialRender]);

  useEffect(() => {
    if (initialRender.current) {
      if (
        selectedValues.toothColors_JSON &&
        availableOptions.toothColors_JSON !== selectedValues.toothColors_JSON
      ) {
        handleSelection("toothColors_JSON", selectedValues.toothColors_JSON);
      }
    }
  }, [selectedValues.toothColors_JSON, availableOptions.toothColors_JSON]);

  const getQuestions = async (orderTypeId) => {
    try {
      let orderTypeIdsToSend;

      if (
        [
          OrderTypeEnum.COMPLEX_ORDER_TYPE_1,
          OrderTypeEnum.COMPLEX_ORDER_TYPE_2,
        ].includes(orderTypeId)
      ) {
        orderTypeIdsToSend = `${OrderTypeEnum.COMPLEX_ORDER_TYPE_1},${OrderTypeEnum.COMPLEX_ORDER_TYPE_2}`;
      } else {
        orderTypeIdsToSend = `${orderTypeId}`; // Pass the selected orderTypeId directly for all other cases
      }

      const response = await axiosInstance.post(
        "/api/Order/getWorkTypeDetailsForOrder",
        {
          orderTypeIds: orderTypeIdsToSend,
        }
      );

      setAllQuestionList(response);
      const firstQuestion = { [listOfOptions[0]]: response };
      setAvailableOptions(firstQuestion);
    } catch (error) {
      console.error("Failed to fetch user data:", error);
    }
  };

  const getUniqueValues = (data, fieldName) => {
    const seen = new Set();
    return (
      data &&
      data.filter((item) => {
        const fieldValue = item[fieldName];
        if (!seen.has(fieldValue)) {
          seen.add(fieldValue);
          return true;
        }
        return false;
      })
    );
  };

  const getAvailableToothColourOptions = (toothColourOptionIds) => {
    var toothColourOptionIdList = toothColourOptionIds.find(
      (x) => x.ToothColorId === orderData?.toothColorId
    );
    return toothColourOptionIdList?.ToothColourOptions?.split(",");
  };

  const getAvailableJawTypes = (jawTypes) => {
    return jawTypes?.length ? JSON.parse(jawTypes[0]?.jawTypes_JSON) : [];
  };

  return (
    <div>
      {/* Job Category Section */}
      {availableOptions?.jobTypeName && (
        <div className="relative mb-5 font-inter">
          <label
            htmlFor="date"
            className="block text-gray-600 text-2xl xl:text-sm 3xl:text-2xl font-inter mb-2"
          >
            ZE-Art
            <sup className="text-red">*</sup>
          </label>

          {/* Error message for Delivery Date */}
          {errors.workTypeId && (
            <p className="text-red text-sm mt-1">{errors.workTypeId}</p>
          )}

          <RadioGroup
            aria-label="Your plan"
            name="people"
            defaultValue="Individual"
          >
            <List
              className="flex flex-row flex-wrap"
              sx={{
                "--List-gap": "0.5rem",
                "--ListItem-paddingX": "1rem",
                "--ListItem-radius": "8px",
              }}
            >
              <div
                style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}
                className="!font-inter job_category_btn m-0"
              >
                {availableOptions?.jobTypeName &&
                  getUniqueValues(
                    availableOptions?.jobTypeName,
                    "jobTypeName"
                  )?.map((obj, index) => (
                    <ListItem
                      key={index}
                      variant="outlined"
                      sx={{
                        width: "max-content",
                        minHeight: "28px",
                        gap: "8px",
                        padding: "3px 8px",
                        margin: "0",
                        backgroundColor: "#F9F9F9",
                        borderColor: "#D9D9D9",
                      }}
                    >
                      <Radio
                        overlay
                        disableIcon
                        value={obj?.jobTypeName}
                        label={obj?.jobTypeName}
                        name={listOfOptions[0]}
                        checked={
                          selectedValues[listOfOptions[0]] === obj?.jobTypeName
                        }
                        onClick={(e) => {
                          updateAndDeleteChildElement(0);
                          handleSelection(e.target.name, e.target.value, true);
                        }}
                        sx={{
                          flexGrow: 1,
                          flexDirection: "row-reverse",
                        }}
                        slotProps={{
                          label: ({ checked }) => ({
                            sx: {
                              fontSize: "14px",
                              color: checked ? "#fcfcfc" : "#8D8D8D",
                            },
                          }),
                          action: ({ checked }) => ({
                            sx: () => ({
                              ...(checked && {
                                inset: -1,
                                border: "2px solid",
                                borderColor: "#376EA4",
                                backgroundColor: "#376EA4",
                              }),
                            }),
                          }),
                        }}
                      />
                    </ListItem>
                  ))}
              </div>
            </List>
          </RadioGroup>
        </div>
      )}

      {/* Job Type Section-1 */}
      {availableOptions?.jobTypeSpecName1 && (
        <div className="relative mb-5 font-inter">
          <label
            htmlFor="date"
            className="block text-gray-600 text-2xl xl:text-sm 3xl:text-2xl font-inter mb-2"
          >
            ZE-Typ<sup className="text-red">*</sup>
          </label>
          <RadioGroup
            aria-label="Your plan"
            name="people"
            defaultValue="Individual"
            defaultChecked={false}
            className="p-0"
          >
            <List
              className="flex flex-row flex-wrap p-0"
              sx={{
                "--List-gap": "0.5rem",
                "--ListItem-paddingX": "1rem",
                "--ListItem-radius": "8px",
              }}
            >
              <div
                style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}
                className="!font-inter job_category_btn p-0"
              >
                {availableOptions?.jobTypeSpecName1 &&
                  getUniqueValues(
                    availableOptions?.jobTypeSpecName1,
                    "jobTypeSpecName1"
                  ).map((obj, index) => (
                    <ListItem
                      key={index}
                      variant="outlined"
                      sx={{
                        width: "max-content",
                        minHeight: "28px",
                        gap: "8px",
                        padding: "3px 8px",
                        margin: "0",
                        backgroundColor: "#F9F9F9",
                        borderColor: "#D9D9D9",
                      }}
                    >
                      <Radio
                        overlay
                        disableIcon
                        name={listOfOptions[1]}
                        value={obj.jobTypeSpecName1}
                        label={obj.jobTypeSpecName1}
                        checked={
                          selectedValues[listOfOptions[1]] ==
                          obj?.jobTypeSpecName1
                        }
                        onClick={(e) => {
                          updateAndDeleteChildElement(1);
                          handleSelection(e.target.name, e.target.value, true);
                        }}
                        sx={{
                          flexGrow: 1,
                          flexDirection: "row-reverse",
                        }}
                        slotProps={{
                          label: ({ checked }) => ({
                            sx: {
                              fontSize: "14px",
                              color: checked ? "#fcfcfc" : "#8D8D8D",
                            },
                          }),
                          action: ({ checked }) => ({
                            sx: () => ({
                              ...(checked && {
                                inset: -1,
                                border: "2px solid",
                                borderColor: "#376EA4",
                                backgroundColor: "#376EA4",
                              }),
                            }),
                          }),
                        }}
                      />
                    </ListItem>
                  ))}
              </div>
            </List>
          </RadioGroup>
        </div>
      )}

      {/* Job Type Section-2 */}
      {availableOptions?.jobTypeSpecName2 && (
        <div className="relative mb-5 font-inter">
          <label
            htmlFor="date"
            className="block text-gray-600 text-2xl xl:text-sm 3xl:text-2xl font-inter mb-2"
          >
            ZE-Typ<sup className="text-red">*</sup>
          </label>
          <RadioGroup
            aria-label="Your plan"
            name="people"
            defaultValue="Individual"
            defaultChecked={false}
            className="p-0"
          >
            <List
              className="flex flex-row flex-wrap p-0"
              sx={{
                "--List-gap": "0.5rem",
                "--ListItem-paddingX": "1rem",
                "--ListItem-radius": "8px",
              }}
            >
              <div
                style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}
                className="!font-inter job_category_btn p-0"
              >
                {availableOptions?.jobTypeSpecName2 &&
                  getUniqueValues(
                    availableOptions?.jobTypeSpecName2,
                    "jobTypeSpecName2"
                  ).map((obj, index) => (
                    <ListItem
                      key={index}
                      variant="outlined"
                      sx={{
                        width: "max-content",
                        minHeight: "28px",
                        gap: "8px",
                        padding: "3px 8px",
                        margin: "0",
                        backgroundColor: "#F9F9F9",
                        borderColor: "#D9D9D9",
                      }}
                    >
                      <Radio
                        overlay
                        disableIcon
                        value={obj.jobTypeSpecName2}
                        label={obj.jobTypeSpecName2}
                        name={listOfOptions[2]}
                        checked={
                          selectedValues[listOfOptions[2]] ==
                          obj?.jobTypeSpecName2
                        }
                        onClick={(e) => {
                          updateAndDeleteChildElement(2);
                          handleSelection(e.target.name, e.target.value, true);
                        }}
                        sx={{
                          flexGrow: 1,
                          flexDirection: "row-reverse",
                        }}
                        slotProps={{
                          label: ({ checked }) => ({
                            sx: {
                              fontSize: "14px",
                              color: checked ? "#fcfcfc" : "#8D8D8D",
                            },
                          }),
                          action: ({ checked }) => ({
                            sx: () => ({
                              ...(checked && {
                                inset: -1,
                                border: "2px solid",
                                borderColor: "#376EA4",
                                backgroundColor: "#376EA4",
                              }),
                            }),
                          }),
                        }}
                      />
                    </ListItem>
                  ))}
              </div>
            </List>
          </RadioGroup>
        </div>
      )}

      {/* Job Type Section-3 */}
      {availableOptions?.jobTypeSpecName3 && (
        <div className="relative mb-5 font-inter">
          <label
            htmlFor="date"
            className="block text-gray-600 text-2xl xl:text-sm 3xl:text-2xl font-inter mb-2"
          >
            ZE-Typ<sup className="text-red">*</sup>
          </label>
          <RadioGroup
            aria-label="Your plan"
            name="people"
            defaultValue="Individual"
            defaultChecked={false}
            className="p-0"
          >
            <List
              className="flex flex-row flex-wrap p-0"
              sx={{
                "--List-gap": "0.5rem",
                "--ListItem-paddingX": "1rem",
                "--ListItem-radius": "8px",
              }}
            >
              <div
                style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}
                className="!font-inter job_category_btn p-0"
              >
                {availableOptions?.jobTypeSpecName3 &&
                  getUniqueValues(
                    availableOptions?.jobTypeSpecName3,
                    "jobTypeSpecName3"
                  ).map((obj, index) => (
                    <ListItem
                      key={index}
                      variant="outlined"
                      sx={{
                        width: "max-content",
                        minHeight: "28px",
                        gap: "8px",
                        padding: "3px 8px",
                        margin: "0",
                        backgroundColor: "#F9F9F9",
                        borderColor: "#D9D9D9",
                      }}
                    >
                      <Radio
                        overlay
                        disableIcon
                        value={obj.jobTypeSpecName3}
                        label={obj.jobTypeSpecName3}
                        name={listOfOptions[3]}
                        checked={
                          selectedValues[listOfOptions[3]] ==
                          obj?.jobTypeSpecName3
                        }
                        onClick={(e) => {
                          updateAndDeleteChildElement(3);
                          handleSelection(e.target.name, e.target.value, true);
                        }}
                        sx={{
                          flexGrow: 1,
                          flexDirection: "row-reverse",
                        }}
                        slotProps={{
                          label: ({ checked }) => ({
                            sx: {
                              fontSize: "14px",
                              color: checked ? "#fcfcfc" : "#8D8D8D",
                            },
                          }),
                          action: ({ checked }) => ({
                            sx: () => ({
                              ...(checked && {
                                inset: -1,
                                border: "2px solid",
                                borderColor: "#376EA4",
                                backgroundColor: "#376EA4",
                              }),
                            }),
                          }),
                        }}
                      />
                    </ListItem>
                  ))}
              </div>
            </List>
          </RadioGroup>
        </div>
      )}

      {/* Material Section */}
      {availableOptions?.materialName && (
        <div className="relative mb-5 font-inter">
          <label
            htmlFor="date"
            className="block text-gray-600 text-2xl xl:text-sm 3xl:text-2xl font-inter mb-2"
          >
            Material<sup className="text-red">*</sup>
          </label>
          <RadioGroup
            aria-label="Your plan"
            name="people"
            defaultValue="Individual"
            className="p-0"
          >
            <List
              className="flex flex-row flex-wrap p-0"
              sx={{
                "--List-gap": "0.5rem",
                "--ListItem-paddingX": "1rem",
                "--ListItem-radius": "8px",
              }}
            >
              <div
                style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}
                className="!font-inter job_category_btn p-0"
              >
                {availableOptions?.materialName &&
                  getUniqueValues(
                    availableOptions?.materialName,
                    "materialName"
                  ).map((obj, index) => (
                    <ListItem
                      key={index}
                      variant="outlined"
                      sx={{
                        width: "max-content",
                        minHeight: "28px",
                        gap: "8px",
                        padding: "3px 8px",
                        margin: "0",
                        backgroundColor: "#F9F9F9",
                        borderColor: "#D9D9D9",
                      }}
                    >
                      <Radio
                        overlay
                        disableIcon
                        value={obj.materialName}
                        label={obj.materialName}
                        defaultChecked={false}
                        name={listOfOptions[4]}
                        checked={
                          selectedValues[listOfOptions[4]] == obj?.materialName
                        }
                        onClick={(e) => {
                          updateAndDeleteChildElement(4);
                          handleSelection(e.target.name, e.target.value, true);
                        }}
                        sx={{
                          flexGrow: 1,
                          flexDirection: "row-reverse",
                        }}
                        slotProps={{
                          label: ({ checked }) => ({
                            sx: {
                              fontSize: "14px",
                              color: checked ? "#fcfcfc" : "#8D8D8D",
                            },
                          }),
                          action: ({ checked }) => ({
                            sx: () => ({
                              ...(checked && {
                                inset: -1,
                                border: "2px solid",
                                borderColor: "#376EA4",
                                backgroundColor: "#376EA4",
                              }),
                            }),
                          }),
                        }}
                      />
                    </ListItem>
                  ))}
              </div>
            </List>
          </RadioGroup>
        </div>
      )}

      {/* Alloy Section */}
      {availableOptions?.alloyTypes_JSON && (
        <div className="relative mb-5 font-inter">
          <label
            htmlFor="date"
            className="block text-gray-600 text-2xl xl:text-sm 3xl:text-2xl font-inter mb-2"
          >
            Legierung<sup className="text-red">*</sup>
          </label>
          <RadioGroup
            aria-label="Your plan"
            name="people"
            defaultValue="Individual"
            className="p-0"
          >
            <List
              className="flex flex-row flex-wrap p-0"
              sx={{
                "--List-gap": "0.5rem",
                "--ListItem-paddingX": "1rem",
                "--ListItem-radius": "8px",
              }}
            >
              <div
                style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}
                className="!font-inter job_category_btn p-0"
              >
                {availableOptions?.alloyTypes_JSON &&
                  [
                    ...new Map(
                      availableOptions?.alloyTypes_JSON
                        .flatMap((item) => JSON.parse(item.alloyTypes_JSON)) // Parse and combine all arrays
                        .map((obj) => [obj.AlloyType, obj]) // Create key-value pairs (AlloyType as key)
                    ).values(), // Keep only unique AlloyType values
                  ].map((alloyTypeObj, index) => (
                    <ListItem
                      key={index}
                      variant="outlined"
                      sx={{
                        width: "max-content",
                        minHeight: "28px",
                        gap: "8px",
                        padding: "3px 8px",
                        margin: "0",
                        backgroundColor: "#F9F9F9",
                        borderColor: "#D9D9D9",
                      }}
                    >
                      <Radio
                        overlay
                        disableIcon
                        value={alloyTypeObj?.AlloyTypeId}
                        label={alloyTypeObj?.AlloyType}
                        name={listOfOptions[5]}
                        checked={alloyType == alloyTypeObj.AlloyTypeId}
                        onClick={(e) => {
                          updateAndDeleteChildElement(5);
                          handleSelection(e.target.name, e.target.value, true);
                          setAlloyType(Number(e.target.value));
                        }}
                        sx={{
                          flexGrow: 1,
                          flexDirection: "row-reverse",
                        }}
                        slotProps={{
                          label: ({ checked }) => ({
                            sx: {
                              fontSize: "14px",
                              color: checked ? "#fcfcfc" : "#8D8D8D",
                            },
                          }),
                          action: ({ checked }) => ({
                            sx: () => ({
                              ...(checked && {
                                inset: -1,
                                border: "2px solid",
                                borderColor: "#376EA4",
                                backgroundColor: "#376EA4",
                              }),
                            }),
                          }),
                        }}
                      />
                    </ListItem>
                  ))}
              </div>
            </List>
          </RadioGroup>
        </div>
      )}

      {/* Coverage Section */}
      {availableOptions?.coverageTypeName && (
        <div className="relative mb-5 font-inter">
          <label
            htmlFor="date"
            className="block text-gray-600 text-2xl xl:text-sm 3xl:text-2xl font-inter mb-2"
          >
            Konstruktionsart<sup className="text-red">*</sup>
          </label>
          <RadioGroup
            aria-label="Your plan"
            name="people"
            defaultValue="Individual"
            className="p-0"
          >
            <List
              className="flex flex-row flex-wrap p-0"
              sx={{
                "--List-gap": "0.5rem",
                "--ListItem-paddingX": "1rem",
                "--ListItem-radius": "8px",
              }}
            >
              <div
                style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}
                className="!font-inter job_category_btn p-0"
              >
                {availableOptions?.coverageTypeName &&
                  getUniqueValues(
                    availableOptions?.coverageTypeName,
                    "coverageTypeName"
                  ).map((obj, index) => (
                    <ListItem
                      key={index}
                      variant="outlined"
                      sx={{
                        width: "max-content",
                        minHeight: "28px",
                        gap: "8px",
                        padding: "3px 8px",
                        margin: "0",
                        backgroundColor: "#F9F9F9",
                        borderColor: "#D9D9D9",
                      }}
                    >
                      <Radio
                        overlay
                        disableIcon
                        value={obj.coverageTypeName}
                        label={obj.coverageTypeName}
                        name={listOfOptions[6]}
                        checked={
                          selectedValues[listOfOptions[6]] ==
                          obj?.coverageTypeName
                        }
                        onClick={(e) => {
                          updateAndDeleteChildElement(6);
                          handleSelection(e.target.name, e.target.value, true);
                        }}
                        sx={{
                          flexGrow: 1,
                          flexDirection: "row-reverse",
                        }}
                        slotProps={{
                          label: ({ checked }) => ({
                            sx: {
                              fontSize: "14px",
                              color: checked ? "#fcfcfc" : "#8D8D8D",
                            },
                          }),
                          action: ({ checked }) => ({
                            sx: () => ({
                              ...(checked && {
                                inset: -1,
                                border: "2px solid",
                                borderColor: "#376EA4",
                                backgroundColor: "#376EA4",
                              }),
                            }),
                          }),
                        }}
                      />
                    </ListItem>
                  ))}
              </div>
            </List>
          </RadioGroup>
        </div>
      )}

      {/* Produktionsschritt  Section */}
      {availableOptions?.workStepName && (
        <div className="relative mb-5 font-inter">
          <label
            htmlFor="date"
            className="block text-gray-600 text-2xl xl:text-sm 3xl:text-2xl font-inter mb-2"
          >
            Produktionsschritt <sup className="text-red">*</sup>
          </label>
          <RadioGroup
            aria-label="Your plan"
            name="people"
            defaultValue="Individual"
            className="p-0"
          >
            <List
              className="flex flex-row flex-wrap p-0"
              sx={{
                "--List-gap": "0.5rem",
                "--ListItem-paddingX": "1rem",
                "--ListItem-radius": "8px",
              }}
            >
              <div
                style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}
                className="!font-inter job_category_btn p-0"
              >
                {availableOptions?.workStepName &&
                  getUniqueValues(
                    availableOptions?.workStepName,
                    "workStepName"
                  ).map((obj, index) => (
                    <ListItem
                      key={index}
                      variant="outlined"
                      sx={{
                        width: "max-content",
                        minHeight: "28px",
                        gap: "8px",
                        padding: "3px 8px",
                        margin: "0",
                        backgroundColor: "#F9F9F9",
                        borderColor: "#D9D9D9",
                      }}
                    >
                      <Radio
                        overlay
                        disableIcon
                        value={obj.workStepName}
                        label={obj.workStepName}
                        name={listOfOptions[7]}
                        checked={
                          selectedValues[listOfOptions[7]] == obj?.workStepName
                        }
                        onClick={(e) => {
                          updateAndDeleteChildElement(7);
                          handleSelection(e.target.name, e.target.value, true);
                        }}
                        sx={{
                          flexGrow: 1,
                          flexDirection: "row-reverse",
                        }}
                        slotProps={{
                          label: ({ checked }) => ({
                            sx: {
                              fontSize: "14px",
                              color: checked ? "#fcfcfc" : "#8D8D8D",
                            },
                          }),
                          action: ({ checked }) => ({
                            sx: () => ({
                              ...(checked && {
                                inset: -1,
                                border: "2px solid",
                                borderColor: "#376EA4",
                                backgroundColor: "#376EA4",
                              }),
                            }),
                          }),
                        }}
                      />
                    </ListItem>
                  ))}
              </div>
            </List>
          </RadioGroup>
        </div>
      )}

      {/* Jaw Type Section */}
      {availableOptions?.jawTypes_JSON && (
        <div className="relative mb-5 font-inter">
          <label
            htmlFor="date"
            className="block text-gray-600 text-2xl xl:text-sm 3xl:text-2xl font-inter mb-2"
          >
            Jaw Type<sup className="text-red">*</sup>
          </label>
          <RadioGroup
            aria-label="Your plan"
            name="people"
            defaultValue="Individual"
            className="p-0"
          >
            <List
              className="flex flex-row flex-wrap p-0"
              sx={{
                "--List-gap": "0.5rem",
                "--ListItem-paddingX": "1rem",
                "--ListItem-radius": "8px",
              }}
            >
              <div
                style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}
                className="!font-inter job_category_btn p-0"
              >
                {availableOptions?.jawTypes_JSON &&
                  getAvailableJawTypes(availableOptions?.jawTypes_JSON).map(
                    (obj, index) => (
                      <ListItem
                        key={index}
                        variant="outlined"
                        sx={{
                          width: "max-content",
                          minHeight: "28px",
                          gap: "8px",
                          padding: "3px 8px",
                          margin: "0",
                          backgroundColor: "#F9F9F9",
                          borderColor: "#D9D9D9",
                        }}
                      >
                        <Radio
                          overlay
                          disableIcon
                          value={obj.JawType}
                          label={obj.JawTypeName}
                          name={listOfOptions[8]}
                          checked={orderData.jawTypeId == obj.JawType}
                          onClick={(e) => {
                            updateAndDeleteChildElement(8);
                            var workTypeId =
                              availableOptions.jawTypes_JSON[0]?.workTypeId;

                            setOrderData((prevState) => ({
                              ...prevState,
                              jawTypeId: obj.JawType,
                            }));

                            setOrderData((prevState) => ({
                              ...prevState,
                              workTypeId: workTypeId,
                            }));
                            setSelectedflow(availableOptions.jawTypes_JSON[0]);

                            handleSelection(
                              e.target.name,
                              availableOptions?.jawTypes_JSON.find((x) =>
                                x.jawTypeId.includes(obj.JawType)
                              ).jawTypes_JSON
                            );
                          }}
                          sx={{
                            flexGrow: 1,
                            flexDirection: "row-reverse",
                          }}
                          slotProps={{
                            label: ({ checked }) => ({
                              sx: {
                                fontSize: "14px",
                                color: checked ? "#fcfcfc" : "#8D8D8D",
                              },
                            }),
                            action: ({ checked }) => ({
                              sx: () => ({
                                ...(checked && {
                                  inset: -1,
                                  border: "2px solid",
                                  borderColor: "#376EA4",
                                  backgroundColor: "#376EA4",
                                }),
                              }),
                            }),
                          }}
                        />
                      </ListItem>
                    )
                  )}
              </div>
            </List>
          </RadioGroup>
        </div>
      )}

      {/* Tooth Colour Section */}
      {/* {availableOptions?.jawTypes_JSON
        ? orderData?.jawTypeId && availableOptions?.toothColors_JSON?.length > 0 */}
      {availableOptions?.toothColors_JSON?.length > 0 && (
        <div className="relative mb-5 font-inter">
          <label
            htmlFor="date"
            className="block text-gray-600 text-2xl xl:text-sm 3xl:text-2xl font-inter mb-2"
          >
            Zahnfarbe
            {/* <sup className="text-red">*</sup> */}
          </label>
          <RadioGroup
            aria-label="Your plan"
            name="people"
            defaultValue="Individual"
            className="p-0"
          >
            <List
              className="flex flex-row flex-wrap p-0"
              sx={{
                "--List-gap": "0.5rem",
                "--ListItem-paddingX": "1rem",
                "--ListItem-radius": "8px",
              }}
            >
              <div
                style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}
                className="!font-inter job_category_btn p-0"
              >
                {availableOptions?.toothColors_JSON &&
                  availableOptions.toothColors_JSON.map(
                    (toothColor, toothColorIndex) => (
                      <ListItem
                        key={toothColorIndex}
                        variant="outlined"
                        sx={{
                          width: "max-content",
                          minHeight: "28px",
                          gap: "8px",
                          padding: "3px 8px",
                          margin: "0",
                          backgroundColor: "#F9F9F9",
                          borderColor: "#D9D9D9",
                        }}
                      >
                        <Radio
                          overlay
                          disableIcon
                          value={toothColor.ToothColorId}
                          label={toothColor.ToothColor}
                          name={listOfOptions[9]}
                          checked={
                            orderData.toothColorId == toothColor.ToothColorId
                          }
                          onClick={async () => {
                            try {
                              await updateAndDeleteChildElement(9);
                              setOrderData((prevState) => ({
                                ...prevState,
                                toothColorId: toothColor.ToothColorId,
                              }));
                            } catch (error) {
                              console.error("Error updating element:", error);
                            }
                          }}
                          sx={{
                            flexGrow: 1,
                            flexDirection: "row-reverse",
                          }}
                          slotProps={{
                            label: ({ checked }) => ({
                              sx: {
                                fontSize: "14px",
                                color: checked ? "#fcfcfc" : "#8D8D8D",
                              },
                            }),
                            action: ({ checked }) => ({
                              sx: () => ({
                                ...(checked && {
                                  inset: -1,
                                  border: "2px solid",
                                  borderColor: "#376EA4",
                                  backgroundColor: "#376EA4",
                                }),
                              }),
                            }),
                          }}
                        />
                      </ListItem>
                    )
                  )}
              </div>
            </List>
          </RadioGroup>
        </div>
      )}

      {/* Tooth ColourOptions Section */}
      {availableOptions?.toothColors_JSON &&
        orderData?.toothColorId &&
        availableOptions?.toothColors_JSON?.length > 0 && (
          <div className="relative mb-5 font-inter">
            <label
              htmlFor="date"
              className="block text-gray-600 text-2xl xl:text-sm 3xl:text-2xl font-inter mb-2"
            >
              Select Tooth Colour Options
              {/* <sup className="text-red">*</sup> */}
            </label>
            <RadioGroup
              aria-label="Your plan"
              name="people"
              defaultValue="Individual"
              className="p-0"
            >
              <List
                className="flex flex-row flex-wrap p-0"
                sx={{
                  "--List-gap": "0.5rem",
                  "--ListItem-paddingX": "1rem",
                  "--ListItem-radius": "8px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    flexWrap: "wrap",
                  }}
                  className="!font-inter job_category_btn p-0"
                >
                  {availableOptions?.toothColors_JSON &&
                    getAvailableToothColourOptions(
                      availableOptions?.toothColors_JSON
                    ).map((toothColorOption, toothColorOptionIndex) => (
                      <ListItem
                        key={toothColorOptionIndex}
                        variant="outlined"
                        sx={{
                          width: "max-content",
                          minHeight: "28px",
                          gap: "8px",
                          padding: "3px 8px",
                          margin: "0",
                          backgroundColor: "#F9F9F9",
                          borderColor: "#D9D9D9",
                        }}
                      >
                        <Radio
                          overlay
                          disableIcon
                          value={toothColorOption}
                          label={toothColorOption}
                          name={listOfOptions[9]}
                          checked={
                            orderData.toothColorOption == toothColorOption
                          }
                          onClick={(e) => {
                            var workTypeId =
                              availableOptions.toothColors_JSON[0]?.workTypeId;

                            setOrderData((prevState) => ({
                              ...prevState,
                              toothColorOption: toothColorOption,
                              workTypeId: workTypeId,
                            }));

                            setSelectedflow(
                              availableOptions.toothColors_JSON[0]
                            );

                            handleSelection(
                              e.target.name,
                              availableOptions?.toothColors_JSON.find(
                                (x) => x.ToothColorId === orderData.toothColorId
                              ).toothColors_JSON
                            );
                          }}
                          sx={{
                            flexGrow: 1,
                            flexDirection: "row-reverse",
                          }}
                          slotProps={{
                            label: ({ checked }) => ({
                              sx: {
                                fontSize: "14px",
                                color: checked ? "#fcfcfc" : "#8D8D8D",
                              },
                            }),
                            action: ({ checked }) => ({
                              sx: () => ({
                                ...(checked && {
                                  inset: -1,
                                  border: "2px solid",
                                  borderColor: "#376EA4",
                                  backgroundColor: "#376EA4",
                                }),
                              }),
                            }),
                          }}
                        />
                      </ListItem>
                    ))}
                </div>
              </List>
            </RadioGroup>
          </div>
        )}

      {(availableOptions.toothColors_JSON
        ? orderData.toothColorId && orderData.toothColorOption
        : availableOptions?.gridLetters &&
          availableOptions?.gridLetters[0]) && (
        <div className="relative mb-5 font-inter">
          <label
            htmlFor="date"
            className="block text-gray-600 text-2xl xl:text-sm 3xl:text-2xl font-inter mb-2"
          >
            Zahnpositionierung
            {/* <sup className="text-red">*</sup> */}
          </label>

          <ToothPosition
            gridLetters={
              availableOptions?.gridLetters
                ? availableOptions?.gridLetters[0]?.gridLetters
                : null
            }
            toothGridInitialRendering={toothGridInitialRendering}
            toothGridData={toothGridData}
            setToothGridData={setToothGridData}
          />
        </div>
      )}
    </div>
  );
};

export default DynamicQuestionRenderingv2;
